//
// inputmask.js
// Theme module
//

import Inputmask from 'inputmask';

const toggles = document.querySelectorAll('[data-inputmask]');
const togglesRegex = document.querySelectorAll('[data-inputmask-regex]');

const options = {
  rightAlign: false,
};

Inputmask(options).mask(toggles);
Inputmask(options).mask(togglesRegex);